/**
 * Converts strings into kebab case.
 *
 * @param {string} str - The string to convert.
 * @returns {string || null}
 */
var toXCase = function toXCase(_case) {
  return function (str) {
    var strMatch = str && str.trim() && str.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g);
    return strMatch && strMatch.map(function (x) {
      return x.toLowerCase();
    }).join(_case);
  };
};
var toKebabCase = toXCase('-');
var toSnakeCase = toXCase('_');

// Converts strings into camel case.
var toCamelCase = function toCamelCase() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var s = str && str.trim() && str.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g).map(function (x) {
    return x.slice(0, 1).toUpperCase() + x.slice(1).toLowerCase();
  }).join('');
  return s.slice(0, 1).toLowerCase() + s.slice(1);
};
var leftPad = function leftPad(str) {
  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
  var char = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '0';
  return String(str).padStart(length, char);
};

export { leftPad, toCamelCase, toKebabCase, toSnakeCase };
